module.exports = __webpack_public_path__ + "img/magento-setup-tuning_small@2x.479bb96c.jpg";